import { IconButton as ButtonIcon, Chip } from '@material-ui/core';

import {
  RiCloseLine as CloseIcon,
  RiBookmarkFill,
  RiBookmarkLine,
} from '@remixicon/react';

import { createFilter, useFilters } from '@spotify/confidence-core-react';

export const FAVORITES_FILTER = createFilter<boolean>({
  id: 'favorites',
  label: 'Favorites',
  query: () => '',
  editor: ({ onClose }) => {
    onClose();
    return null;
  },
  viewer: ({ onRemove }) => (
    <Chip label="Favorites" onDelete={onRemove} deleteIcon={<CloseIcon />} />
  ),
});

export const useFavoritesFilterToggle = () => {
  const { activeFilters, addFilter, removeFilter } = useFilters();
  const isActive = activeFilters.some(f => f.id === FAVORITES_FILTER.id);
  const toggle = () => {
    if (isActive) {
      removeFilter(FAVORITES_FILTER.id);
    } else {
      addFilter(FAVORITES_FILTER, true);
    }
  };

  return { isActive, toggle };
};

export const FavoritesFilterToggle = () => {
  const { isActive, toggle } = useFavoritesFilterToggle();

  return (
    <ButtonIcon
      size="small"
      onClick={toggle}
      aria-label="Filter favourites"
      style={
        isActive
          ? {
              backgroundColor: 'var(--essential-bright-accent)',
              color: '#000', // TODO(encore): use .encore-bright-accent-set class + var(--text-base)
              borderRadius: 'var(--encore-corner-radius-base)',
              width: 32,
              height: 32,
            }
          : {
              backgroundColor: 'var(--background-tinted-base)',
              borderRadius: 'var(--encore-corner-radius-base)',
              width: 32,
              height: 32,
            }
      }
    >
      {isActive ? <RiBookmarkFill size={16} /> : <RiBookmarkLine size={16} />}
    </ButtonIcon>
  );
};
